import React, { useEffect, useState } from 'react';
import { EventoSebraeService } from '../../../services/eventoSebraeService';
import { TableAdmin } from '../../../../../components/TableAdmin';
import { BaSeDialogContext } from '@base/react';
import {
  MainContent,
  SubTitle,
} from '../../../../../components/StyledComponents';
import { handleModalAdmin } from '../../../../../utils/handleModalAdmin';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

export const GerenciarEventoSebrae = () => {
  const history = useHistory();
  const { showModal } = React.useContext(BaSeDialogContext);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(null);  

  const getData = async (source) => {
    try {
      const response = await EventoSebraeService.findAll();
      setIsLoading(false);
      setData(response);
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Requisição cancelada', error.message);
      } else {
        console.log(error.message);
      }
    }
  };

  const handleDeleteClick = (idEvento) => {
    handleModalAdmin({
      title: `Excluir evento`,
      content: `Você tem certeza que deseja excluir este evento?`,
      msgOnSuccess: `Evento excluído com sucesso`,
      onFinish: () => {
        setIsLoading(true);
        getData();
      },
      onConfirmClick: async () => await EventoSebraeService.delete(idEvento),
      onCancelClick: () => console.log('modal closed...'),
      showModal: showModal,
    });
  };

  const handleEditClick = (idEvento) => {
    history.push(`/tabelas-de-controle/EventoSebrae/${idEvento}/edit`);
  };

  useEffect(() => {
    getData();
    // https://github.com/facebook/create-react-app/issues/6880
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const tableColumns = [
    {
      field: 'nome',
      id: 'nome',
      label: 'Nome do Evento',
      minWidth: 10,
    },
    {
      field: 'endpoint',
      id: 'endpoint',
      label: 'Endpoint de Integração',
      minWidth: 10,
      align: 'left',
    },
    {
      field: 'codigoEvento',
      id: 'codigoEvento',
      label: 'Código de Integração',
      minWidth: 50,
      align: 'left',
    },
    {
      field: 'actions',
      id: 'actions',
      label: '',
      minWidth: 150,
      align: 'left',
    },
  ];

  return (
    <MainContent>
      <SubTitle>
        <>
          <h3>Gerenciar</h3>
        </>
      </SubTitle>

      <TableAdmin
        data={data}
        columnAction={'actions'}
        pagination={false}
        columns={tableColumns}
        isLoading={isLoading}
        tableColor={'#0061C6'}
        lineColor={'rgba(0, 97, 198, 0.1)'}
        handleDeleteClick={handleDeleteClick}
        handleEditClick={handleEditClick}
      />
    </MainContent>
  );
};
